module.exports = __webpack_public_path__ + "img/form.e4d4709f.svg";